<template>
  <Popover class="relative isolate z-40">
    <PopoverButton class="flex items-center justify-center gap-x-1 w-full px-6 lg:px-8 py-3">
      <Square2StackIcon class="h-5 w-5 font-semibold text-gray-600 mr-2" aria-hidden="true" />
      <span class="text-sm font-semibold leading-6 text-gray-600">
        Anwendung
      </span>
    </PopoverButton>
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 -translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-1"
    >
      <PopoverPanel class="absolute inset-x-0 bg-gray-100 rounded-lg shadow-lg ring-1 ring-gray-900/5 overflow-hidden">
        <div class="divide-y divide-gray-200">
          <!-- Practice -->
          <PracticeCardMenuItem @click="details">
            <template #title>
              Methode öffnen
            </template>
            <template #icon>
              <ChevronRightIcon class="h-5 w-5 text-gray-500" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <!-- Experiment -->
          <PracticeCardMenuItem @click="experiment">
            <template #title>
              Experiment starten
            </template>
            <template #icon>
              <ChevronRightIcon class="h-5 w-5 text-gray-500" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <!-- Application -->
          <PracticeCardMenuItem v-if="applied" @click="unapply">
            <template #title>
              Dauerhaft in Anwendung
            </template>
            <template #icon>
              <CheckCircleIcon class="h-5 w-5 text-gray-800" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <PracticeCardMenuItem v-else="applied" @click="apply">
            <template #title>
              Dauerhaft in Anwendung
            </template>
            <template #icon>
              <PlusCircleIcon class="h-5 w-5 text-gray-500" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <!-- Bookmark -->
          <PracticeCardMenuItem v-if="bookmarked" @click="unbookmark">
            <template #title>
              Für später merken
            </template>
            <template #icon>
              <CheckCircleIcon class="h-5 w-5 text-gray-800" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <PracticeCardMenuItem v-else="bookmarked" @click="bookmark">
            <template #title>
              Für später merken
            </template>
            <template #icon>
              <PlusCircleIcon class="h-5 w-5 text-gray-500" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <!-- Rejection -->
          <PracticeCardMenuItem v-if="rejected" @click="unreject">
            <template #title>
              Nicht mehr empfehlen
            </template>
            <template #icon>
              <CheckCircleIcon class="h-5 w-5 text-gray-800" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
          <PracticeCardMenuItem v-else="rejected" @click="reject">
            <template #title>
              Nicht mehr empfehlen
            </template>
            <template #icon>
              <PlusCircleIcon class="h-5 w-5 text-gray-500" aria-hidden="true" />
            </template>
          </PracticeCardMenuItem>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore} from 'vuex';
import client from '@/client/index';

const props = defineProps({practice: Object});
const model = ref(props.practice);
const router = useRouter();
const store = useStore();

const context = computed(() => store.getters['context/context']);

const applied = ref(props.practice.applied ?? false);
const rejected = ref(props.practice.rejected ?? false);
const bookmarked = ref(props.practice.bookmarked ?? false);

const details = () =>
{
  const name = {name: 'practices.show'};
  const params = {params: {id: model.value.id}};
  router.push({...name, ...params});
};

const experiment = () =>
{
  const name = {name: 'experiments.create'};
  const query = {query: {practice_id: model.value.id}};
  router.push({...name, ...query});
};

const bookmark = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/bookmarks';
  const params = {practice_id: model.value.id};

  client.post(target, params)
  .then(result => bookmarked.value = true)
  .catch(error => bookmarked.value = false);
};

const unbookmark = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/bookmarks';
  const params = {practice_id: model.value.id};

  client.delete(target, {data: params})
  .then(result => bookmarked.value = false)
  .catch(error => bookmarked.value = true);
};

const reject = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/rejections';
  const params = {practice_id: model.value.id};

  client.post(target, params)
  .then(result => rejected.value = true)
  .catch(error => rejected.value = false);
};

const unreject = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/rejections';
  const params = {practice_id: model.value.id};

  client.delete(target, {data: params})
  .then(result => rejected.value = false)
  .catch(error => rejected.value = true);
};


const apply = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/applications';
  const params = {practice_id: model.value.id};

  client.post(target, params)
  .then(result => applied.value = true)
  .catch(error => applied.value = false);
};

const unapply = () =>
{
  const target = '/api/podcasts/' + context.value.id + '/applications';
  const params = {practice_id: model.value.id};

  client.delete(target, {data: params})
  .then(result => applied.value = false)
  .catch(error => applied.value = true);
};
</script>
